import type { RouterConfig } from '@nuxt/schema';
import { RouterMeta } from '@/routing/config';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';

export default {
	// https://router.vuejs.org/api/interfaces/routeroptions.html#routes
	scrollBehavior: (to, from, savedPosition) => {
		// the sports tab has several children pages that should keep scroll position independently.
		// each sports route has a meta.data identifier which will be used to keep the scroll position distinct for each child page.
		const tab = (
			to?.meta?.tab === 'sports' ? `${to?.meta?.tab}-${to?.meta?.data}` : to?.meta?.tab
		) as RouterMeta['tab'];

		// sports event is pretty much the equivalent to the detail page.
		// thus its scroll position needs to be reset every time it gets looked up.
		// same-route navigations (e.g. ?page= query param updates) should not reset scroll.
		// `path` identifies the page.
		const isSameRoute = to.name === from?.name;
		const isSamePath = to.path === from?.path;
		const reusesNameAcrossResources =
			tab === 'detail' || (typeof to?.name === 'string' && to.name.startsWith('app.sports.subdomain.event'));
		const isSameRouteInstance = reusesNameAcrossResources ? isSameRoute && isSamePath : isSameRoute;
		if (
			(tab === 'detail' ||
				tab === 'editorial' ||
				(typeof to?.name === 'string' && to.name.startsWith('app.sports.subdomain.event'))) &&
			!isSameRouteInstance
		) {
			if (tab === 'editorial' && savedPosition) {
				return savedPosition;
			}
			return { left: 0, top: 0 };
		}
		const routingStore = useRoutingStore();

		if ((routingStore.scrollPositions as Record<string, number>)[tab]) {
			return { left: 0, top: (routingStore.scrollPositions as Record<string, number>)[tab] };
		}

		if (savedPosition) {
			return savedPosition;
		}

		return { left: 0, top: 0 };
	},
} satisfies RouterConfig;
